import { Trans, useTranslation } from 'react-i18next';
import { ButtonVariant } from 'src/components/atoms/Button';
import { ManualUploadTile } from 'src/components/DUP/molecules/ManualUploadTile/ManualUploadTile';

import {
  ButtonsContainer,
  Container,
  HelpText
} from 'src/components/DUP/molecules/WizardProofOfIncome/styles';
import { DocumentInstructionsLink } from 'src/components/DUP/molecules/WizardProofOfIncome/WizardProofOfIncome';
import { useApplication } from 'src/context/ApplicationContext';

import { Icon } from 'src/components/atoms/Icon';
import { BankLinkingTile } from 'src/components/DUP/molecules/BankLinkingTile/BankLinkingTile';
import { StyledButton } from 'src/pages/DUPPage/styles';
import {
  getRequiredDocAmt,
  REQUIRED_DOCS_TRANSLATION_PREFIX
} from 'src/pages/DUPPage/useRequiredDocsModal';
import { UnauthenticateSessionProofType } from 'src/types/api';

const MANUAL_SUPPORTING_TRANSLATION_PREFIX = 'dup.wizard.manualSupportingTile';
const BANK_LINKING_TRANSLATION_PREFIX = 'dup.wizard.bankLinkingSupportingTile';

export const WizardSupportingDocuments = () => {
  const { t } = useTranslation();
  const {
    property,
    isBankLinkingEnabled,
    bankLinking: { isLoadingBankAccounts },
    steps: { onFinished, goBack }
  } = useApplication();

  const proofType = UnauthenticateSessionProofType.BankStatement;
  const uploadProps = {
    title: t(`${MANUAL_SUPPORTING_TRANSLATION_PREFIX}.title`),
    buttonVariant: isBankLinkingEnabled ? ButtonVariant.outline : ButtonVariant.contained,
    textContent: [
      <Trans key="manual-payroll-content-0">
        {t(`${REQUIRED_DOCS_TRANSLATION_PREFIX}bankStatementRequirement`, {
          count: getRequiredDocAmt(proofType, property),
          propertyName: property.name
        })}
      </Trans>,
      <>
        {t(`${MANUAL_SUPPORTING_TRANSLATION_PREFIX}.text.part1`)}
        <DocumentInstructionsLink>
          {t(`${MANUAL_SUPPORTING_TRANSLATION_PREFIX}.text.part2`)}
        </DocumentInstructionsLink>
      </>
    ],
    proofType: UnauthenticateSessionProofType.BankStatement
  };

  const bankLinkingProps = {
    title: t(`${BANK_LINKING_TRANSLATION_PREFIX}.title`),
    subtitle: t(`${BANK_LINKING_TRANSLATION_PREFIX}.subtitle`),
    textContent: [
      <>{t(`${BANK_LINKING_TRANSLATION_PREFIX}.text.1`)}</>,
      <>{t(`${BANK_LINKING_TRANSLATION_PREFIX}.text.2`)}</>
    ],
    icon: <Icon icon="check-recommended" />
  };

  return (
    <Container>
      {isBankLinkingEnabled ? <BankLinkingTile {...bankLinkingProps} /> : <></>}
      <ManualUploadTile {...uploadProps} />
      <HelpSection />
      <ButtonsContainer justify="space-between">
        <StyledButton
          name="back"
          onClick={() => {
            goBack();
          }}
          variant={ButtonVariant.outline}
        >
          {t('buttonLabel.back')}
        </StyledButton>
        <StyledButton
          name="next"
          onClick={onFinished}
          variant={ButtonVariant.contained}
          isLoading={isLoadingBankAccounts}
          isDisabled={isLoadingBankAccounts}
        >
          {t('buttonLabel.next')}
        </StyledButton>
      </ButtonsContainer>
    </Container>
  );
};

export const HelpSection = () => {
  const { t } = useTranslation();

  return (
    <HelpText>
      {t('dup.wizard.helpText.part1')}
      <a href={t('dup.wizard.helpText.howToVideoUrl')} target="_blank" rel="noreferrer">
        {t('dup.wizard.helpText.part2')}
      </a>
    </HelpText>
  );
};
